import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../utils/config';

const useFetchSiteSettings = ( token ) => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            if ( !token ) return;

            setLoading( true );
            setError( null );

            try {
                const response = await axios.get( API_ENDPOINTS.SITE_METADATA, {
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        Authorization: `Bearer ${token}`,
                    },
                });

                const siteData = response?.data?.items || null;
                if ( siteData ) {
                    localStorage.setItem( 'settings', JSON.stringify( siteData ) );
                    setSettings( siteData );
                } else {
                    console.warn( 'Site metadata response missing "items" key.' );
                }
            } catch ( error ) {
                console.error( 'Settings fetch error:', error.message );
                setError( error );
            } finally {
                setLoading( false );
            }
        };

        fetchSettings();
    }, [token]);

    return { settings, loading, error };
};

export default useFetchSiteSettings;
